<template>
  <div class="songs">
    <div class="row row-2" v-for="(entry, index) in entries" :key="index">
      <div>
        <label v-if="index == 0" :for="'writer-' + index" class="form-label"><span>Compositore</span></label>
        <input type="text" :name="'writer-' + index" v-model="entry.writer" placeholder="Compositore" @change="updateSongsFields(entry)">
      </div>
      <div>
        <label v-if="index == 0" :for="'song-' + index" class="form-label"><span>Brano</span></label>
        <input type="text" :name="'song-' + index" v-model="entry.song" placeholder="Brano" @change="updateSongsFields(entry)">
      </div>
      <div @click.prevent="remove(index)" class="remove" v-if="index > 0"></div>
    </div>

    <div class="row row-1" v-if="!AreAllSongsFieldsCorrectlyFilled">
      <div class="message">I campi dei brani musicali devono essere correttamente compilati</div>
    </div>


    <div class="add"><a href="#0"
                        @click.prevent="add"
                        class="button button-small button-aqua button-anim"
                        :disabled="!AreAllSongsFieldsCorrectlyFilled">Aggiungi canzone?</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isClearSongs'],

  data() {
    return {
      entries: [{
        song: '',
        writer: ''
      }]
    }
  },

  computed: {

      AreAllSongsFieldsCorrectlyFilled : function() {

          var unfilledSongs = 0;
          this.entries.forEach((entry) => {

              if (entry.song == "" || entry.writer == "") unfilledSongs +=1;
          })

          console.log("AreAllSongsFieldsCorrectlyFilled", unfilledSongs == 0)

          return (unfilledSongs == 0);

      }

  },
    
    
  watch: {
    entries: function(newVal, oldVal) {
      this.$emit('update', this.entries);
    },

    isClearSongs: function(newVal, oldVal) {
      if(newVal) {
        this.entries = [{song: '', writer: ''}];
        this.$emit('emptied');
      }
    }
  },

  methods: {
    add: function() {

        if(this.AreAllSongsFieldsCorrectlyFilled) this.entries.push({song: '', writer: ''});
        else alert("I campi di ogni brano deve essere correttamente compilati");

    },

    remove: function(index) {
      this.entries.splice(index, 1);
    },

    updateSongsFields: function(entry) {
        this.$emit('updateSongsFields', this.entries);
    }

  }
}
</script>




// WEBPACK FOOTER //
// src/vue/components/ReportEntries.vue